import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3d3714e7")
const _hoisted_1 = { class: "title" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fadeTools && _ctx.fadeTools(...args))),
      id: "close"
    }, [
      _createVNode(_component_CloseSVG, {
        fillColor: '#424753',
        strokeColor: '#fff',
        flipFill: '#fff',
        flipStroke: '#424753',
        propId: 'tool-title-close'
      })
    ])
  ]))
}